import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { ErrorView } from "@components";

const ErrorInternalServerError = (props: { statusCode: number }) => {
    const router = useRouter();
    let title = "An unknown error occurred ";
    let message = "An unknown error occurred ";
    switch (props.statusCode) {
        case 500:
            title = "Internal Server Error";
            message = "An internal server error occurred";
            break;
        default:
            break;
    }

    return (
        <div>
            <Head>
                <title>{title} | RoboEpics</title>
                <meta name="viewport" content="initial-scale=1.0, width=device-width" />
            </Head>
            <ErrorView url={router.asPath.toString()} errorMessage={message} statusCode={props.statusCode} />
        </div>
    );
};

ErrorInternalServerError.getInitialProps = ({ res, err }) => {
    const statusCode = res ? res.statusCode : err ? err.statusCode : null;
    return { statusCode };
};

export default ErrorInternalServerError;
